// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const CommissionOperationType =
{                                   // значения используются в ключах локализации для InstrumentDetails - имя не менять
    ALL: 0,
    BUY: 1,
    SHORT: 2,
    SELL: 3,
    OPEN: 4,
    CLOSE: 5,
    OPENBUY: 6,
    OPENSELL: 7,
    OPENSHORT: 8,
    CLOSEBUY: 9,
    CLOSESELL: 10
}